var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 23,
    viewBox: "0 0 32 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2745 12.5607C31.8603 11.9749 31.8603 11.0251 31.2745 10.4393L21.7286 0.893398C21.1428 0.307611 20.1931 0.307611 19.6073 0.893398C19.0215 1.47919 19.0215 2.42893 19.6073 3.01472L28.0926 11.5L19.6073 19.9853C19.0215 20.5711 19.0215 21.5208 19.6073 22.1066C20.1931 22.6924 21.1428 22.6924 21.7286 22.1066L31.2745 12.5607ZM0.786011 13H30.2139V10H0.786011V13Z",
    fill: "#939393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.89a563c21b368510a52fdec55b274404.svg";
export { ForwardRef as ReactComponent };